import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React from "react";

function WrapperLoader(props) {
  const customSpinnerIcon = <LoadingOutlined spin />;
  return (
    <Spin
      className="mt-2"
      size="small"
      spinning={props.isLoading}
      indicator={customSpinnerIcon}
    >
      {props.isLoading ? "" : props.children}
    </Spin>
  );
}

export default WrapperLoader;
